export default {
  创建新标准库: 'Create a new standard library',
  跳转绘图列表: 'Jump to drawing list',
  跳转类别管理: 'Jump category management',
  跳转实体管理: 'Jump to entity management',
  升版: 'Upgrade',
  缩略图: 'thumbnail',
  代码: 'code',
  名称: 'name',
  版本: 'vesion',
  状态: 'state',
  备注: 'remarks',
  工作中: 'working',
  已审批: 'approved',
  新增标准: 'New standard',
  修改标准: 'Modify standard',
  英文名称: 'English Name',
  中文名称: 'Chinese Name',
  参考数据: 'Reference Data',
  来源系统: 'Source system',
  来源数据表: 'Source data sheet',
  来源数据字段: 'Source data fields',
  来源PK: 'Source PK',
  类别: 'category',
  上级: 'superior',
  新增规则: 'new rules',
  编辑规则: 'edit rules',
  规则类型: 'rule type',
  请填写规则正则: 'Please fill in the rule regular',
  请填写规则内容: 'Please fill in the content of the rule',
  您尚有未保存的数据是否取消: 'Whether you have unsaved data canceled?',
  提示: 'Tips',
  是: 'Yes',
  否: 'No',
  添加到任务: 'Add to a task',
  数据源描述: 'Data source description',
  数据源类型: 'Data source type',
  数据源编码: 'Data source encoding',
  数据源名称: 'The name of the data source',
  创建人: 'Created by',
  数据源模型: 'Data source model',
  外部数据源: 'External data sources',
  外部数据源连接: 'External data source connections',
  测试连接: 'Test the connection',
  任务名称: 'Task name',
  运行状态: 'Running status',
  开始日期: 'Start date',
  结束日期: 'End date',
  创建人姓名: 'Creator name',
  序号: 'Seq No',
  执行频次: 'Frequency of execution',
  上次运行时间: 'Last run time',
  上次运行状态: 'Last run status',
  上次运行耗时秒: 'Elapsed last run (seconds)',
  下次运行时间: 'Next run time',
  总运行次数: 'Total number of runs',
  失败次数: 'Number of failures',
  任务创建人: 'Task creator',
  最近修改人: 'Recently modified by',
  修改时间: 'Modification time',
  请输入任务名称: 'Please enter a task name',
  质检源: 'Quality inspection source',
  执行频度: 'Frequency of execution',
  任务状态: 'Task status',
  请选择任务状态: 'Please select Task Status',
  是否重试: 'Whether to retry',
  重试次数: 'Number of retries',
  请输入次数: 'Please enter the number of times',
  间隔时间: 'Interval time',
  请输入间隔时间: 'Please enter an interval',
  失败原因: 'Reason for failure',
  关联表: 'Associate tables',
  请选择业务主题域: 'Please select a business subject domain',
  请输入表名或中文名称: 'Please enter a table name or Chinese name',
  表名: 'Table name',
  实体中文名称: 'The name Chinese entity',
  实体说明: 'Entity description',
  规则: 'rule',
  请输入属性中文名称: 'Please enter a name Chinese the attribute',
  属性英文名称: 'The English name of the property',
  属性中文名称: 'The property Chinese name',
  消息设置: 'Message settings',
  规则问题情况: 'Rule problem situations',
  规则描述或规则类型: 'Rule description or rule type',
  报告: 'report',
  规则内容: 'Rule content',
  规则描述: 'Rule description',
  检查数: 'Number of checks',
  问题数: 'Number of questions',
  问题比例: 'Question ratio',
  影响类库: 'Affects class libraries',
  字段明细情况: 'Field details',
  搜索类别代码或类别名称: 'Search for a category code or category name',
  问题总数: 'Total number of issues',
  详情: 'detail',
  后退: 'back',
  通知设置: 'Notification settings',
  请选择通知设置: 'Please select notification settings',
  通知方式: 'Notification method',
  请选择通知方式: 'Please select a notification method',
  通知标题: 'Notification title',
  请输入标题: 'Please enter a title',
  通知接收人: 'Notification of recipients',
  多个人以逗号分隔: 'Multiple people are separated by commas',
  通知描述: 'Notification description',
  请输入描述内容: 'Please enter a description',
  发送日志: 'Send logs',
  整改状态: 'Remediation status',
  数据表: 'Datasheet',
  稽核数据量: 'Audit data volume',
  异常数据量: 'Unusual amount of data',
  整改: 'Rectification',
  整改记录: 'Rectification records',
  整改时间: 'Rectification time',
  整改项: 'Rectification items',
  第几行: 'A few lines',
  整改前: 'Before rectification',
  整改后: 'After rectification',
  异常描述: 'Exception description',
  整改人: 'Rectify people',
  操作人: 'Operator',
  操作时间: 'Operation time',
  返回: 'back',
  提交审核: 'Submit for review',
  审批批次号: 'Approval batch number',
  审批数据表: 'Approve the data sheet',
  审批状态: 'Approval status',
  审批意见: 'Approval opinions',
  操作者: 'operator',
  数据审批设置: 'Data approval settings',
  数据审批编辑: 'Data approval edits',
  请选择数据标准库: 'Please select a data standard library',
  数据标准库: 'Data Standard Library',
  操作: 'operate',
  审批人: 'Approver',
  请选择数据表: 'Please select a datasheet',
  请填写审批意见: 'Please fill in the approval comments',
  审批通过: 'Approved',
  审批驳回: 'Approval rejection',
  查看文件: 'View the file',
  请选择主题: 'Please select a topic',
  请选择属性: 'Please select an attribute',
  请选择操作符: 'Please select the operator',
  请输入关键字: 'Please enter a keyword',
  资产: 'asset',
  基本信息: 'Basic information',
  实体: 'entity',
  归类属性: 'Collation properties',
  实体集名称: 'The entity set name',
  归类实体属性: 'Collation entity properties',
  归类实体属性值: 'Collate entity property values',
  引用实体列表: 'Reference a list of entities',
  启用: 'enable',
  停用: 'Deactivate',
  编码: 'code',
  资产数据维度编码: 'Asset data dimension coding',
  资产数据维度名称: 'Asset data dimension name',
  标准: 'standard',
  描述: 'description',
  资产数据维度描述: 'Asset data dimension description',
  限定数据标签: 'Qualify data labels',
  数据标签: 'Data labels',
  限定实体归集: 'Qualified entity collections',
  实体归集: 'Entity aggregation',
  展开属性: 'Expand Properties',
  引用实体: 'Reference entities',
  显示属性: 'Display properties',
  是否递归展示: 'Whether to display recursively',
  层级: 'Level',
  描述文字: 'Descriptive text',
  请输入主题名称: 'Please enter a subject name',
  请输入实体名称或实体编码: 'Please enter the entity name or entity number',
  实体代码: 'Entity code',
  实体名称: 'Entity name',
  搜索代码: 'Search for the code',
  搜索名称: 'Search for the name',
  打开方式: 'Open with',
  操作类别: 'Action category',
  响应者: 'Responder',
  参数: 'parameter',
  新增业务操作: 'Add a new business operation',
  编辑业务操作: 'Edit a business action',
  查看业务操作: 'View business operations',
  参数名: 'The parameter name',
  属性: 'attribute',
  业务操作: 'Business operations',
  呈现方式: 'Rendering mode',
  参数属性: 'Parameter properties',
  按钮名或提示: 'Button name or hint',
  测点编码或测点名称: 'Measurement point code or measurement point name',
  单位: 'unit',
  测点周期: 'Measurement point period',
  测点类型: 'Measurement point type',
  测点驱动: 'Measurement point drive',
  测点编码: 'Measurement point coding',
  测点名称: 'Measurement point name',
  请填写测点编码: 'Please fill in the measurement point code',
  请填写测点名称: 'Please fill in the name of the measurement point',
  请填写单位: 'Please fill in the unit',
  请填写测点周期: 'Please fill in the measurement point period',
  请填写表达式: 'Please fill in the expression',
  请填写量程上限: 'Please fill in the upper mileage limit',
  请填写量程下限: 'Please fill in the lower measuring range',
  请填写测点序号: 'Please fill in the measurement point serial number',
  请选择专业: 'Please select a major',
  请选择机组: 'Please select a unit',
  量程上限: 'Maximum range',
  量程下限: 'Lower range',
  实时数据查询: 'Real-time data queries',
  历史数据查询: 'Historical data query',
  颗粒度: 'Granularity',
  趋势曲线: 'Trend curve',
  测点: 'Measurement point',
  机组: 'unit',
  实时值: 'Real-time values',
  时间: 'time',
  数值: 'numeric value',
  名称描述: 'Name/Description',
  类型: 'type',
  支撑应用数: 'Support the number of applications',
  调用次数: 'Number of calls',
  API定义: 'API definition',
  API验证: 'API validation',
  API名称: 'API name',
  API代码: 'API code',
  地址: 'address',
  调用建议: 'Call suggestions',
  使用场景: 'Usage scenarios',
  API类型: 'API type',
  请求方式: 'The method of the request',
  引用属性: 'Reference properties',
  属性别名: 'Property alias',
  查询方式: 'Query mode',
  请求字段: 'Request fields',
  返回字段: 'Returns the field',
  请以openapi开头: 'Please start with /openapi/',
  请输入API名称: 'Please enter the API name',
  请输入API代码: 'Please enter the API code',
  API简要描述: 'A brief description of the API',
  API调用建议: 'API call suggestions',
  API使用场景说明: 'Description of API usage scenarios',
  验证: 'verify',
  表格: 'table',
  API格式: 'API format',
  申请应用: 'Apply for an app',
  申请部门: 'Applying Department',
  是否启用: 'Whether it is enabled',
  请选择状态: 'Please select a status',
  申请人: 'applicant',
  申请描述: 'Application description',
  API接口: 'API interface',
  目标系统: 'Target system',
  目标表: 'Target table',
  目标表中文名: 'The Chinese name of the target table',
  更新时间: 'Update time',
  更新状态: 'Update status',
  apsql语句: 'API/SQL statements',
  字段映射: 'Field mapping',
  目标字段: 'Target field',
  源系统: 'Source system',
  源数据库: 'Source database',
  源字段: 'Source field',
  目标字段中文名: 'The target field Chinese name',
  采集来源: 'Collection source',
  源数据库表名: 'The source database table name',
  源字段中文名: 'The source field Chinese name',
  请选择审批人: 'Please select an approver',
  新增: 'Add',
  编辑: 'Edit',
  对象编码: 'Object encoding',
  对象名称: 'Object name',
  信息类别: 'Information category',
  confirmContinueIgnoreIsExist:
    'There is a dictionary with the same name in the system. Do you want to continue',
  codeOrName: 'code or name',
}
